import * as HTTP from "./http";
import { INursery, ITankStats } from "@/types/data";
import { IListApiReponse } from "@/types/api";

export function getNurseries(): Promise<IListApiReponse<INursery>> {
  return HTTP.get("/api/v1/nurseries/")
    .then(r => {
      if (!r.ok) throw new Error("Unable to get nurseries.");
      return r.json();
    });
}

export function getNursery(nurseryId: string): Promise<INursery> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/`)
    .then(r => {
      if (r.status === 404) throw new Error("Nursery not found.");
      if (!r.ok) throw new Error("Unable to get nursery. Please try again.");

      return r.json();
    });
}

export function getNurseryStats(nurseryId: string): Promise<ITankStats[]> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/stats/`)
    .then(r => {
      if (r.status === 404) throw new Error("Nursery not found.");
      if (!r.ok) throw new Error("Unable to get nursery. Please try again.");

      return r.json();
    });
}
